import type { FC } from 'react';
import type { ProviderDto } from '@/queries/providers';
import { useTranslations } from 'next-intl';
import ProviderCard from '@/components/entities/providers/ProviderCard';
import { ProviderSkeleton } from '@/components/entities/providers/ProviderSkeleton';
import EmptyStateVisual from '@/components/shared/EmptyStateVisual';
import { ProvidersGrid } from './components/ProvidersGrid';

interface ProviderListContentProps {
  isFetching: boolean;
  items?: ProviderDto[];
  defaultPageSize: number;
}

export const ProviderListContent: FC<ProviderListContentProps> = ({ isFetching, items, defaultPageSize }) => {
  const t = useTranslations('providers.providers-list');

  if (isFetching) {
    return (
      <ProvidersGrid>
        {Array.from({ length: defaultPageSize }).map((_, index) => (
          <ProviderSkeleton key={index} />
        ))}
      </ProvidersGrid>
    );
  }

  if (items && items.length > 0) {
    return (
      <ProvidersGrid>
        {items.map(provider => (
          <ProviderCard key={provider.id} provider={provider} />
        ))}
      </ProvidersGrid>
    );
  }

  if (items) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-2">
        <EmptyStateVisual />
        <p className="text-white heading-h6">{t('empty-state-search-title')}</p>
      </div>
    );
  }

  return null;
};
